import RequestBehaviour from '../base/RequestBehaviour';

export default class VoidTransaction extends RequestBehaviour {
	/**
	 * Payment UUID
	 */
	payment_uuid?: string = undefined;

	/**
	 * Reason for void the order
	 */
	void_reason?: string = undefined;

	/**
	 * Required signature for void authentication
	 */
	void_signature?: string = undefined;
}
